<!--<div class="welcome" *ngIf="!loginDisplay">-->
<!--  <mat-spinner></mat-spinner>-->
<!--</div>-->

<app-auth *ngIf="!loginDisplay"></app-auth>

<ng-container *ngComponentOutlet="activeDashboard"></ng-container>


<ng-template #checkOrgNumberDialog>
  <div class="dialog-wrapper">
    <mat-dialog-content>
    <div class="check-number-header">
      <img class="logo" src="assets/brand/klidi-logo.svg" alt="Klidi">
      <h1 class="text-black font-weight-600">Check company registration number</h1>
      <p>Enter the company registration number in the entry field</p>
    </div>
    <div class="form-control">
      <mat-form-field>
        <input #input type="text" matInput [required]="true" placeholder="Registration number">
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <button class="btn" mat-button [disabled]="!input.value" (click)="checkOrganizationNumber(input.value)">Confirm</button>
  </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #confirmCompanyJoinDialog>
  <div class="dialog-wrapper">
  <mat-dialog-content>
    <div class="check-number-header">
      <img class="logo" src="assets/brand/klidi-logo.svg" alt="Klidi">
      <h1 class="text-black font-weight-600">Do you want to join the company?</h1>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <button class="btn-join" mat-button (click)="onReject()">Cancel</button>
    <button class="btn-join" (click)="onConfirmJoin()" mat-button>Confirm</button>
  </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #newCompanyDialog>
  <div class="dialog-wrapper">
  <mat-dialog-content>
    <div class="check-number-header">
      <img class="logo" src="assets/brand/klidi-logo.svg" alt="Klidi">
      <h1 class="text-black font-weight-600">Do you want to create a company?</h1>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <button class="btn-join" mat-button (click)="onReject()">Cancel</button>
    <button class="btn-join" (click)="onCompanyCreate()" mat-button>Confirm</button>
  </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #companySelectDialog>
  <div class="dialog-wrapper">
    <div class="dialog-header" mat-dialog-title>
      <button (click)="dialog.closeAll()" mat-icon-button aria-label="Close dialog">
        <mat-icon>
          clear
        </mat-icon>
      </button>
    </div>
    <mat-dialog-content>
      <div class="check-number-header">
        <img class="logo" src="assets/brand/klidi-logo.svg" alt="Klidi">
        <h1 class="text-black font-weight-600">Select a company</h1>
        <mat-form-field>
          <mat-select (valueChange)="onCompanySelect($event)">
            <mat-option *ngFor="let option of companies | sortBy:'name'" [value]="option.id">
              {{option.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="actions">
      <button class="btn-join" mat-button (click)="dialog.closeAll()">Cancel</button>
      <button class="btn-join" (click)="goToModules()" mat-button>Confirm</button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #moduleSelectDialog>
  <div class="dialog-wrapper">
    <div class="dialog-header" mat-dialog-title>
      <button (click)="dialog.closeAll()" mat-icon-button aria-label="Close dialog">
        <mat-icon>
          clear
        </mat-icon>
      </button>
    </div>
    <mat-dialog-content>
      <div class="check-number-header">
        <img class="logo" src="assets/brand/klidi-logo.svg" alt="Klidi">
        <h1 class="text-black font-weight-600">Select a module</h1>
        <mat-form-field>
          <!-- Driven by ModulesService (the switcher's own source) rather than a hardcoded list:
               that list only offered Home / Invoicing / Compliance, so anyone whose access was HR,
               Reporting, Tax, Accounting or Inventory was asked to pick and shown none of theirs. -->
          <mat-select
            (ngModelChange)="onModuleSelect($event)"
            [(ngModel)]="selectedModule">
            <mat-option *ngFor="let module of moduleOptions" [value]="module.id">
              {{ module.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="actions">
      <button class="btn-join" mat-button (click)="dialog.closeAll()">Cancel</button>
      <button class="btn-join" (click)="selectModule()" mat-button>Confirm</button>
    </mat-dialog-actions>
  </div>
</ng-template>
